import React from 'react'
import { OmDropdownMenu, OmProgress, OmSpinner, OmTooltip, OmButton } from '@owma/kit'
import FTIcon from 'components/FTIcon'

import i18n from 'i18n'
import classNames from 'classnames'

import { formatBytes } from 'utils/ui'

// import closeBtnSVG from 'assets/images/close-small.svg'
import downIcon from 'assets/images/chevron-down-gray-24.svg'
import closeIcon from 'assets/images/icon-close-round.svg'

import { SVGImageCurrentColor } from 'utils/svgHelper'

import helper from './helper'

import styles from './style.module.scss'

interface AttachmentProps {
  attachmentObj: any
  api?: any
  enableDelete?: boolean
  downloadable?: boolean
  forEditor?: boolean
}

interface AttachmentState {
  file: any
  percent: number
  isEnabled: boolean
  thumbUrl: string | null
  thumbLoading: boolean
  error: any
}

class Attachment extends React.Component<AttachmentProps, AttachmentState> {
  state: AttachmentState = {
    file: {},
    percent: -1,
    isEnabled: true,
    thumbUrl: null,
    thumbLoading: false,
    error: null,
  }

  ref: any = null
  downloadObj: any = null

  componentDidMount() {
    const { attachmentObj, api } = this.props
    const { file, error } = attachmentObj
    const { name, type } = file

    if (api != null && api.setUploadCB != null) {
      api.setUploadCB(this.onProgress)
    }

    if (name === null && type === 'message/rfc822') {
      this.setState({
        thumbLoading: true,
        error,
      })
      console.log(' --- file: ', file)
      this.preDownload()
    } else {
      this.setState({
        file,
        error,
      })
    }

    i18n.on('languageChanged', this.onLanguageChanged)

    // download 완료 시 data-blob-url attribute 갱신을 위해 listener 등록.
    // helper.ts의 attachment.download() then이 RAF로 호출.
    attachmentObj?.addDownloadCompleteListener?.(this.handleDownloadComplete)
  }

  componentDidUpdate(prevProps: AttachmentProps) {
    // 동일 컴포넌트 인스턴스에서 attachmentObj props가 다른 객체로 교체될 수 있음.
    // 이 경우 prev에서 listener를 해제하고 new에 재등록해 누수/오작동 방지.
    if (prevProps.attachmentObj !== this.props.attachmentObj) {
      prevProps.attachmentObj?.removeDownloadCompleteListener?.(this.handleDownloadComplete)
      this.props.attachmentObj?.addDownloadCompleteListener?.(this.handleDownloadComplete)
    }
  }

  componentWillUnmount() {
    i18n.off('languageChanged', this.onLanguageChanged)
    this.props.attachmentObj?.removeDownloadCompleteListener?.(this.handleDownloadComplete)
  }

  onLanguageChanged = () => {
    this.forceUpdate()
  }

  // attachment.downloadObj의 path/downloadPath가 mutation으로 채워진 뒤
  // helper.ts가 호출하는 리스너. data-blob-url attribute를 갱신하기 위해 re-render.
  handleDownloadComplete = () => {
    this.forceUpdate()
  }

  onProgress = (evt: any, percent: number, error: any) => {
    console.log('onProgress - ', evt, percent)

    // console.log(' !!!!!! 2 -  ', this.state)

    if (error != null) {
      this.setState({
        percent: 50,
        error,
      })
      return
    }

    this.setState({
      percent,
    })

    // console.log(' !!!!!! 3 -  ', this.state)

    if (percent >= 100) {
      setTimeout(() => {
        this.progressEnded()
        // console.log(' !!!!!! 4 -  ', this.state)
      }, 500)
    }
  }

  progressEnded = () => {
    this.setState({
      percent: -1,
      isEnabled: true,
    })
  }

  setFileElem = (ref: any) => {
    if (ref != null) {
      this.ref = ref
      // console.log(' ---- ref ---- ', ref, ref.innerText)
      const elems = ref.querySelectorAll('span')
      if (elems.length > 0) {
        requestAnimationFrame(() => {
          // const w = elems[1].offsetWidth // + 1
          let w = elems[1].offsetWidth // + 1;
          const wStr = window.getComputedStyle(elems[1], null).width
          if (wStr.substring(wStr.length - 2) === 'px') {
            const num = wStr.substring(0, wStr.length - 2)
            w = window.parseFloat(num)
          }
          if (ref.offsetWidth > w) {
            elems[1].style.maxWidth = `${w}px`
            if (w === 0) {
              elems[0].style.maxWidth = `100%`
            } else {
              elems[0].style.maxWidth = `calc(100% - ${w}px)`
            }
          }
        })
      }
    }
  }

  deleteAttachment = (e?: any) => {
    const { enableDelete, attachmentObj } = this.props
    // console.log(' delete attachment')

    if (enableDelete !== false) {
      attachmentObj.delete()
    }

    if (e != null) {
      e.stopPropagation()
    }
  }

  download = (onDownload?: any) => {
    const { attachmentObj } = this.props

    return attachmentObj.download(this.onProgress).then((ret: any) => {
      console.log('download - ', ret)
      if (onDownload != null) {
        onDownload(ret)
      }
    })
  }

  preDownload = () => {
    return this.download((ret: any) => {
      this.downloadObj = ret

      const { attachmentObj } = this.props
      const { file } = attachmentObj

      const newFile = {
        ...file,
      }

      if (ret.newFileName != null) {
        newFile.name = ret.newFileName
      }

      this.setState({
        file: newFile,
        thumbLoading: false,
      })
    })
  }

  downloadFile = () => {
    if (this.downloadObj == null) {
      this.download((ret: any) => {
        if (ret.saveFile != null) {
          ret.saveFile()
        }
      })
    } else {
      this.downloadObj.saveFile()
    }
  }

  onClick = (e: any) => {
    // const { downloadable, attachmentObj } = this.props
    // const { file } = attachmentObj

    // if (downloadable === true) {
    //   this.downloadFile(file);
    // }

    const { attachmentObj } = this.props
    if (attachmentObj.showPreview() !== true) {
      this.downloadFile()
    }

    e.stopPropagation()
  }

  showPreview = () => {
    const { attachmentObj } = this.props
    attachmentObj.showPreview()
  }

  getDropDownAttrs = () => {
    const { file } = this.state
    const { enableDelete, downloadable } = this.props

    const items: any[] = []

    if (helper.isPreviewEnable(file) === true) {
      items.push({
        label: i18n.t('editor.menu.preview'),
        key: 'preview',
      })
    }

    // if (enableOpen !== false) {
    //   items.push({
    //     label: i18n.t('editor.menu.open'),
    //     key: 'open',
    //   });
    // }

    if (downloadable !== false) {
      items.push({
        label: i18n.t('editor.menu.download'),
        key: 'download',
      })
    }

    if (enableDelete !== false) {
      items.push({
        label: i18n.t('editor.menu.deleteAttachment'),
        key: 'delete',
      })
    }

    const menu = {
      items,
      onClick: (e: any) => {
        console.log(' --- download : ', e)

        if (e.key === 'download') {
          this.downloadFile()
        } else if (e.key === 'delete') {
          this.deleteAttachment()
        } else if (e.key === 'preview') {
          this.showPreview()
        }
      },
      // selectable: true,
      // selectedKeys: [searchType],
    }

    const dropdownAttrs = {
      overlayClassName: classNames('contextMenu'),
      menu,
      // trigger: isMobile ? ['click'] : ['hover'],
      // destroyOnHidden: false,
    }

    return dropdownAttrs
  }

  cancel = () => {
    const { attachmentObj } = this.props
    if (attachmentObj.isUploading === true) {
      attachmentObj.delete()
    } else if (attachmentObj.isDownloading === true) {
      attachmentObj.cancelProgress()
    } else if (attachmentObj.error != null) {
      attachmentObj.delete()
    }
    this.progressEnded()
  }

  render() {
    const { file, percent, isEnabled, thumbLoading, error } = this.state
    const { enableDelete, downloadable, forEditor } = this.props

    const { name, size, type } = file

    const progressElem =
      percent >= 0 && percent <= 100 ? (
        <OmProgress
          className={classNames(styles.progress, { [styles.error]: error != null })}
          percent={percent}
          showInfo={false}
        />
      ) : (
        ''
      )

    const thumbImg = (
      <div className={styles.fileIcon}>
        <FTIcon fileName={name as any} />
      </div>
    )

    const wrapperClsMap: any = {}
    const clsMap: any = {}

    clsMap[styles.icon] = true
    wrapperClsMap.iconItem = true
    clsMap[type] = true
    clsMap[styles.isProgressing] = percent >= 0 && percent <= 100
    clsMap[styles.error] = error != null
    clsMap.forEditor = forEditor === true

    const isClosable = isEnabled && enableDelete !== false

    clsMap[styles.closable] = isClosable

    const nameTxt = name || ''

    // 확장자가 표시되게 하거나, 감추는 걸 여기서 결정.
    let pos = -1 // nameTxt.lastIndexOf('.')

    if (pos < 0) {
      pos = nameTxt.length
    }

    const front = nameTxt.substring(0, pos)
    const end = nameTxt.substring(pos)

    const tooltipAttrs = {
      title: name,
      arrow: false,
      className: classNames(styles.attachmentTooltip),
    }

    const filenameElem = (
      <div
        ref={(ref) => {
          this.setFileElem(ref)
        }}
        className={classNames(styles.filename)}
      >
        <span className={styles.front}>{front}</span>
        <span className={styles.end}>{end}</span>
      </div>
    )

    const fileExt = nameTxt.substring(nameTxt.lastIndexOf('.') + 1, nameTxt.length)

    const dropdownAttrs = this.getDropDownAttrs()

    let rightElem = null

    if ((percent >= 0 && percent <= 100) || error != null) {
      rightElem = (
        <div
          className={classNames(styles.menu, styles.cancelWrapper, {
            [styles.error]: error != null,
          })}
        >
          <OmButton
            variant="text"
            icon={<SVGImageCurrentColor src={closeIcon} alt="close" />}
            onClick={this.cancel}
          />
        </div>
      )
    } else {
      rightElem =
        downloadable === true ? (
          <OmDropdownMenu {...dropdownAttrs}>
            <div className={styles.menu}>
              <img src={downIcon} alt="menu" />
            </div>
          </OmDropdownMenu>
        ) : null
    }

    let errMessage = null
    if (error != null) {
      errMessage = error.message
      if (error.i18nInfo != null) {
        /* i18next-extract-disable-next-line */
        errMessage = i18n.t(error.i18nInfo.key, error.i18nInfo.params) as string
      }
    }

    const descElem =
      error != null ? (
        <span className={classNames(styles.fileError)}>{errMessage}</span>
      ) : (
        <span className={styles.fileSize}>{formatBytes(size, 0, true)}</span>
      )

    // sweep이 main document outerHTML로 사용 여부를 검사하므로 attachment가 마운트되어 있는
    // 동안 path/downloadPath를 attribute로 노출해 보호 신호로 삼는다. download 전에는 빈 문자열.
    const blobUrlAttr: Record<string, string> = {}
    const downloadObj = this.props.attachmentObj?.downloadObj
    if (downloadObj?.path != null && downloadObj.path.length > 0) {
      blobUrlAttr['data-blob-url'] = downloadObj.path
    }
    if (downloadObj?.downloadPath != null && downloadObj.downloadPath.length > 0) {
      blobUrlAttr['data-blob-download-url'] = downloadObj.downloadPath
    }

    return (
      <div
        className={classNames(styles.attachmentItemWrapper, 'attachmentItemWrapper', wrapperClsMap)}
        {...blobUrlAttr}
      >
        <div className={classNames(styles.attachmentItem, 'attachmentItem', clsMap)}>
          <OmSpinner spinning={thumbLoading}>
            <OmTooltip {...tooltipAttrs}>
              <div className={styles.fileInfo}>
                <div role="button" tabIndex={-1} onKeyDown={() => {}} onClick={this.onClick}>
                  {filenameElem}
                  <div className={styles.line2}>
                    <span className={styles.fileExt}>{fileExt}</span>
                    {descElem}
                  </div>
                  {thumbImg}
                </div>
                {rightElem}
              </div>
            </OmTooltip>
          </OmSpinner>
          {progressElem}
          {/*
          <Button
            className={styles.closeBtn}
            type="default"
            size="small"
            shape="circle"
            icon={<img src={closeBtnSVG} alt="close" />}
            onClick={this.deleteAttachment}
          />
*/}
        </div>
      </div>
    )
  }
}

export default Attachment
